import { Component, h } from 'preact'
import Phrase from '../../libs/translationsUtils/phrase'
import axios from 'axios'
import { Leaderboard } from './interfaces'
import { LeaderboardEmptyMessage, LeaderboardPlaceholderTable, LeaderboardUserListTable } from './components'
import Pagination from '../ui-components/Pagination'

const DEFAULT_PAGE = 1
const DEFAULT_PAGE_SIZE = 50
const PERIOD_THIS_WEEK = 'thisWeek'
const PERIOD_ALL_TIME = 'allTime'

interface Props {
    period: string
}

interface State {
    weekly: Leaderboard,
    allTime: Leaderboard,
    period: string,
    isLoading: boolean
}

class LeaderboardOverview extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      weekly: {
        usersList: [],
        totalPages: 0,
        currentPage: DEFAULT_PAGE
      },
      allTime: {
        usersList: [],
        totalPages: 0,
        currentPage: DEFAULT_PAGE
      },
      period: props.period,
      isLoading: false
    }
    this.fetchLeaderboard = this.fetchLeaderboard.bind(this)
    this.generateNextUrl = this.generateNextUrl.bind(this)
  }

  async componentDidMount () {
    const params = new URLSearchParams(window.location.search)
    const page = params.get('page') || '1'
    await this.fetchLeaderboard(this.props.period, parseInt(page))
  }

  async fetchLeaderboard (period: string, page: number = DEFAULT_PAGE) {
    if (period !== this.state.period) {
      window.history.pushState(null, '', 'leaderboard')
    }
    this.setState({
      period: period,
      isLoading: true
    })

    try {
      const res = await axios.get('/leaderboard/fetch', {
        params: {
          period: period,
          page: page,
          pageSize: DEFAULT_PAGE_SIZE
        }
      })

      if (res.data) {
        const { result, totalPages, currentPage } = res.data
        if (period === PERIOD_THIS_WEEK) {
          const weeklyData = {
            usersList: result,
            totalPages: totalPages,
            currentPage: currentPage
          }
          this.setState({ weekly: weeklyData, isLoading: false })
        } else {
          const allTimeData = {
            usersList: result,
            totalPages: totalPages,
            currentPage: currentPage
          }
          this.setState({ allTime: allTimeData, isLoading: false })
        }
      }
    } catch {
      this.setState({ isLoading: false })
    }
  }

  generateNextUrl (newPage: number) {
    const { period } = this.state
    const baseUrl = '/leaderboard'
    const newPagination = newPage === 1 ? `?period=${period}` : `?period=${period}&page=${newPage}`
    return `${window.location.origin}${baseUrl}${newPagination}`
  }

  render (_: Props, { period, weekly, allTime, isLoading }: State) {
    const leaderboardData = period === PERIOD_THIS_WEEK ? weekly : allTime
    const { usersList, totalPages, currentPage } = leaderboardData
    const isLeaderboardEmpty = usersList.length === 0
    return (
      <div className='leaderboard-overview-container'>
        <div className='leaderboard-header-container'>
          <div><h1 className='leaderboard-overview-title'> <Phrase p='leaderboard.page.title' /> </h1></div>
          <div className='leaderboard-time-period-container'>
            <div className={period === 'thisWeek' ? 'link--active' : 'link--text'} onClick={() => this.fetchLeaderboard(PERIOD_THIS_WEEK)}>
              <Phrase p={`leaderboard.points.thisWeek`} />
            </div>
            <div className='leaderboard-time-period-separator'> |</div>
            <div className={period === 'allTime' ? 'link--active' : 'link--text'} onClick={() => this.fetchLeaderboard(PERIOD_ALL_TIME)}>
              <Phrase p={`leaderboard.points.allTime`} />
            </div>
          </div>
        </div>
        <div>
          {!isLoading && isLeaderboardEmpty && <LeaderboardEmptyMessage /> }
          {isLoading || isLeaderboardEmpty ? <LeaderboardPlaceholderTable /> : null}
          {!isLoading && !isLeaderboardEmpty && <LeaderboardUserListTable usersList={usersList} />}
          {!isLoading && !isLeaderboardEmpty && totalPages > 1 && <Pagination totalPageCount={totalPages} currentPage={currentPage} generateNewUrl={this.generateNextUrl} />}
        </div>
      </div>
    )
  }
}
export default LeaderboardOverview
